'use client'
import {
  Button_default
} from "./chunk-EGOGHW2A.mjs";

// src/BottomSheet/BottomSheet.tsx
import { Fragment, useEffect, useRef, useState } from "react";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { twMerge } from "tailwind-merge";
import { Drawer } from "vaul";
import { useDeviceDetect } from "@wbk/hooks";
import { jsx, jsxs } from "react/jsx-runtime";
var BottomSheet = ({
  render,
  body,
  show,
  onClose,
  closeButton,
  modal,
  backdropDismiss = true,
  stickyHeader,
  stickyFooter,
  rounded,
  fullscreen,
  className,
  sectionClassName,
  ignoreHistory,
  title = "",
  description = ""
}) => {
  const isClosing = useRef(false);
  const { isWebView } = useDeviceDetect();
  const [isOpen, setOpen] = useState(false);
  const externalState = typeof show !== "undefined";
  const internalOpen = externalState ? show : isOpen;
  const open = () => {
    setOpen(true);
  };
  const close = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };
  const back = () => {
    if (ignoreHistory) {
      return close();
    }
    if (isClosing.current)
      return;
    isClosing.current = true;
    history.back();
  };
  useEffect(() => {
    const on = externalState ? show : isOpen;
    if (on && !ignoreHistory) {
      history.pushState("", "");
      window.onpopstate = () => {
        close();
      };
      isClosing.current = false;
    }
  }, [show, isOpen, ignoreHistory]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    render && render({ close: back, open, isOpen: internalOpen }),
    /* @__PURE__ */ jsx(
      Drawer.Root,
      {
        onRelease: (_, open2) => {
          if (!open2) {
            back();
          }
        },
        open: internalOpen,
        modal,
        repositionInputs: false,
        children: /* @__PURE__ */ jsxs(Drawer.Portal, { children: [
          /* @__PURE__ */ jsx(
            Drawer.Overlay,
            {
              onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (backdropDismiss) {
                  back();
                }
              },
              className: "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 bg-body-dark/20 fixed inset-0 z-50"
            }
          ),
          /* @__PURE__ */ jsxs(
            Drawer.Content,
            {
              className: twMerge(
                "bg-body fixed inset-x-0 bottom-0 z-50 flex h-auto max-h-full w-full flex-col overflow-hidden outline-none",
                rounded ? "rounded-t-3xl" : "",
                fullscreen ? "h-full" : "",
                className
              ),
              children: [
                /* @__PURE__ */ jsx(VisuallyHidden, { children: /* @__PURE__ */ jsx(Drawer.Title, { children: title }) }),
                /* @__PURE__ */ jsx(VisuallyHidden, { children: /* @__PURE__ */ jsx(Drawer.Description, { children: description }) }),
                /* @__PURE__ */ jsxs("header", { className: "relative z-10 bg-inherit", children: [
                  /* @__PURE__ */ jsx("div", { className: "after:bg-body-level-1 relative flex h-8 shrink-0 items-center justify-center after:h-[5px] after:w-9 after:rounded-full" }),
                  stickyHeader && stickyHeader({ close: back })
                ] }),
                /* @__PURE__ */ jsx("section", { className: twMerge("max-h-svh overflow-y-auto", sectionClassName), children: body({ close: back }) }),
                stickyFooter && /* @__PURE__ */ jsx(
                  "footer",
                  {
                    className: `bg-body border-paper fixed bottom-0 w-full border-t shadow-sm ${isWebView ? "pb-8" : "safe-bottom"}`,
                    children: stickyFooter({ close: back })
                  }
                ),
                closeButton && /* @__PURE__ */ jsx(Drawer.Close, { asChild: true, children: /* @__PURE__ */ jsx(
                  Button_default,
                  {
                    className: "absolute top-6 z-20 p-px ltr:right-4 rtl:left-4",
                    theme: "transparent",
                    shape: "text",
                    "aria-label": "Close",
                    onClick: back,
                    children: /* @__PURE__ */ jsx("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", children: /* @__PURE__ */ jsx(
                      "path",
                      {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M4.16679 2.98828L10.0001 8.82162L15.8335 2.98828L17.012 4.16679L11.1786 10.0001L17.012 15.8335L15.8335 17.012L10.0001 11.1786L4.16679 17.012L2.98828 15.8335L8.82162 10.0001L2.98828 4.16679L4.16679 2.98828Z",
                        fill: "currentColor"
                      }
                    ) })
                  }
                ) })
              ]
            }
          )
        ] })
      }
    )
  ] });
};
var BottomSheet_default = BottomSheet;

export {
  BottomSheet_default
};
//# sourceMappingURL=chunk-SDMTUDJR.mjs.map